import { createFileRoute } from '@tanstack/react-router';

import { RecruitmentPage } from '@/features/admin/recruitment/RecruitmentPage';
import { parseRecruitmentSearch } from '@/features/admin/recruitment/candidates';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/admissions')({
  beforeLoad: () => requireRouteAccess('/admin/admissions'),
  validateSearch: parseRecruitmentSearch,
  component: RecruitmentRoute,
});

function RecruitmentRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RecruitmentPage
      view={search.view ?? 'board'}
      onViewChange={(view) => void navigate({ search: { view }, replace: true })}
    />
  );
}
